export class UserData {
  public accessRole: AccessRole = AccessRole.NoAccess;
  public userId: number = 0;
  public userAccountId: number = 0;
  public clubId: number = 0;
  public affiliateId: number = 0;
  public isSuperAdmin: boolean = false;
  public user: LoginUser = new LoginUser();
  public canCreateEvents: boolean = false;

  get isUser(): boolean {
    return this.accessRole === AccessRole.User;
  }

  public isAdministrator(): boolean {
    return this.accessRole === AccessRole.Administrator || this.accessRole === AccessRole.EventAdministrator;
  }

  public isLimitedCanCreateEvents(): boolean {
    if (this.accessRole !== AccessRole.Limited) {
      return true;
    }

    return this.canCreateEvents;
  }
}

export enum ClubApproveStatus {
  Unknown = -1,
  NotApproved,
  Approved,
  Blocked,
}

export enum AccessRole {
  NoAccess = 0,
  Administrator = 1,
  User = 2,
  Limited = 3,
  Finance = 4,
  EventAdministrator = 7,
}

export class LoginUser {
  public firstName: string = '';
  public lastName: string = '';
  public fullName: string = '';
  public email: string = '';
  public mobile: string = '';
}
